function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.7297 11.7568C81.7748 10.5811 82.8198 10.5811 83.8649 11.7568L86.2162 13.9122C87.2613 15.0878 87.2613 16.1982 86.2162 17.2432L27.4324 76.027C26.2568 77.2027 25.1464 77.2027 24.1014 76.027L0.783784 52.7095C-0.261261 51.6644 -0.261261 50.5541 0.783784 49.3784L3.13514 47.223C3.52703 46.7005 4.04955 46.4392 4.7027 46.4392C5.35586 46.4392 5.87838 46.7005 6.27027 47.223L25.6689 66.6216L80.7297 11.7568Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkThin);
export default __webpack_public_path__ + "static/media/checkmark-thin.2078c2dd6a4a0bc39c4f71ecefdf9cea.svg";
export { ForwardRef as ReactComponent };